/* A hook for getting access to the context value */
import React from 'react';
import { MermaidContextV3 } from 'Components/utils/Mermaid/MermaidContextV3';

const useMermaidV3 = () => React.useContext(MermaidContextV3);

export default useMermaidV3;
